import { Button, Grid, withStyles } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'
import { CreateApartment, UpdateAllApartmentCodes } from '../../../actions/types'
import FormContainer from '../../../components/Container/FormContainer'
import { MuiClasses } from '../../../types'
import { Apartment } from '../../../types/apartments'

const styles = () => ({
  button: {
    borderColor: '#4f9b44',
    borderWidth: '2px',
    color: '#4f9b44',
    '&:hover': {
      borderColor: '#4f9b44',
      borderWidth: '2px'
    }
  }
})

interface AdminApartmentsToolbarProps {
  classes: MuiClasses
  createApartment: CreateApartment
  updateAllApartmentCodes: UpdateAllApartmentCodes
  apartments: Apartment[]
  t: i18n.TFunction
}

const AdminApartmentsToolbar: FC<AdminApartmentsToolbarProps> = ({
  t,
  createApartment,
  updateAllApartmentCodes,
  apartments,
  classes
}) => {
  const handleUpdateAllCodes = () => {
    if (window.confirm(t('adminApartments.updateAllCodesConfirm'))) {
      updateAllApartmentCodes(apartments)
    }
  }

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item sm={3}>
        <Grid container direction='column' spacing={1}>
          <Grid item>
            <FormContainer
              form='CreateApartmentForm'
              submitButton
              submitAction={createApartment}
              customClasses={classes.button}
              buttonLabel={t('profile.createApartment')}
            />
          </Grid>
          <Grid item>
            <Button variant='outlined' onClick={handleUpdateAllCodes}>
              {t('adminApartments.updateAllCodes')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(AdminApartmentsToolbar)
